import { SupervisorType } from "../action-types";
import { Supervisor } from "../actions";

interface SupervisorRepoState {
    settings: string;
}

const initialState = {
    settings: '',
}

const SupervisorReducer = (
    state: SupervisorRepoState = initialState,
    action: Supervisor
): SupervisorRepoState => {
    
    switch (action.type) {
        case SupervisorType.SET_SETTINGS:  
             return {
                ...state,
                settings: action.payload
             };
        default:
            return state;
    }
};
export default SupervisorReducer;